import styled from 'styled-components';

const NavItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
  margin-top: 50px;
`;

export default NavItems;
